import { Scope, TranslateOptions } from 'i18n-js'
import { addLocaleData, FormattedMessage, IntlProvider, MessageValue } from 'react-intl'
import * as enLocaleData from 'react-intl/locale-data/en'
import * as jaLocaleData from 'react-intl/locale-data/ja'
import * as viLocaleData from 'react-intl/locale-data/vi'
import * as React from 'react'

addLocaleData([...enLocaleData, ...jaLocaleData, ...viLocaleData])

export function t(scope: Scope, options?: TranslateOptions) {
  return I18n.t(scope, options)
}

// HTMLを差し込み文言を生成する
export function formatted(
  scope: string,
  values?: { [key: string]: MessageValue | JSX.Element },
  options?: TranslateOptions
) {
  const message = t(
    scope,
    Object.keys(values || {}).reduce((o, k) => {
      return { ...o, [k]: `{${k}}` }
    }, options || {})
  )
  return (
    <IntlProvider locale={I18n.locale} messages={{ [scope]: message }}>
      <FormattedMessage id={scope} values={values} />
    </IntlProvider>
  )
}
